import {
  Input,
  SignatureCanvas,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import messages from './messages';
import useIntl from '../../../hooks/useIntl';
import { ChangeEvent, useCallback } from 'react';

type Form = {
  signature: string | null,
  printedName: string | null,
};

type Props = {
  onChange: (data: Form) => void,
  signatureData?: string,
  inputValue?: string,
  disabled?: boolean,
};

const SignatureForm = ({
  onChange,
  signatureData,
  inputValue,
  disabled,
}: Props) => {
  const intl = useIntl();

  const onCanvasChange = useCallback(
    (signature: string | null) => {
      onChange({
        signature,
        printedName: inputValue,
      });
    },
    [inputValue],
  );

  const onInputChange = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => {
      onChange({
        printedName: evt.target.value,
        signature: signatureData,
      });
    },
    [signatureData],
  );

  return (
    <>
      <SignatureCanvas
        clearButtonLabel="Clear"
        label={intl.formatMessage(messages.reportSignatureLabel)}
        onChange={onCanvasChange}
        trim={false}
        type="image/png"
        canvasProps={{
          sx: {
            height: 120,
          },
        }}
        disabled={disabled}
        signatureData={signatureData}
      />
      <Input
        label={intl.formatMessage(messages.reportInputLabel)}
        helperText={intl.formatMessage(messages.reportInputHelper)}
        InputProps={{
          sx: {
            color: 'black', // For some reason the text was not black
          },
        }}
        disabled={disabled}
        onChange={onInputChange}
        value={inputValue}
      />
    </>
  );
};

export default SignatureForm;
